<template>
  <transition name="modal" v-if="popShow">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-body">
            <div class="modal-close" @click="hide()">×</div>
            <div class="modal-content">
              <p>
                Facebook Login is no longer working. Please use our Email Login
                by resetting your password by clicking
                <router-link to="password">this link</router-link>.
              </p>
              <p style="text-align: center">
                <router-link
                  class="email_button hover_effect"
                  to="password"
                  tag="button"
                  style="width: 52%"
                  >Reset password</router-link
                >
              </p>
              <p>
                Enter the email associated with your Facebook account at time of
                registration. You will get an email with a link to create a
                password to log in. YOU ONLY NEED TO DO THIS ONCE. Afterwards,
                you can log in using our Email Login using this link.
              </p>
              <p>
                If you are having trouble resetting your password or
                experiencing any other issues, please contact
                <a href="mailto:$__SUPPORT_EMAIL">$__SUPPORT_EMAIL</a>
                with your username (name in the game) and we will help you get
                back in.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "fbDeprecatedModal",
  data: function () {
    return {
      popShow: false,
    };
  },

  methods: {
    show: function () {
      this.popShow = true;
    },
    hide: function () {
      this.popShow = false;
    },
  },
};
</script>


<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  width: 320px;
  margin: 30px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
}
.modal-close {
  position: relative;
  top: -22px;
  left: 300px;
  color: #fff;
  text-align: center;
  text-decoration: none;
  font-size: 30px;
  height: 40px;
  width: 40px;
  border-radius: 40px;
  background-color: #666;
  cursor: pointer;
}
.modal-content {
  padding: 0px 30px 30px 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/FBDeprecatedModal.vue